<template>
  <div class="flex-fill messages-container pa-2">
    <div
      v-if="!messages.length"
      class="d-flex align-center justify-center fill-height mx-5">
      <div class="text-center">
        <div class="mb-2">
          <Icon
            :width="50"
            :height="50"
            class="mr-3"
            :color="'#E6E6E6'"
            :icon="'android-messages'"
          />
        </div>
        <h3 class="font-weight-regular mb-1">
          Está bien <br> que uses el chat.
        </h3>
        <h4 class="text--secondary font-weight-light m-0">
          Escribe un mensaje para que todos lo vean.
        </h4>
      </div>
    </div>
    <div v-else>
      <div
        class="message-cont px-2 py-1 d-flex"
        v-for="(message, index) in messages"
        :key="`message-${index}`"
      >
        <div class="message-card">
          <div class="d-flex align-top mb-0">
            <div
              v-if="message.author.profileImage"
              class="mr-3 mt-2"
            >
              <v-avatar :width="30">
                <v-img
                  :src="message.author.profileImage"
                  :alt="message.author.name"
                >
                </v-img>
              </v-avatar>
            </div>
            <div class="w-100">
              <v-sheet
                elevation="0"
                rounded
                class="py-1 px-2"
                color="rgb(247, 247, 247)"
              >
                <div
                  v-if="message.parent"
                  class="reply mb-2"
                >
                  <small> Respuesta a {{ message.parent.author_name }} <br></small>
                  <small> {{ message.parent.message }}</small>
                </div>
                <div style="position: relative;">
                  <div class="header-data">
                    <small>
                      {{ creationTime(message.created_at) }}
                    </small>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <button
                          @click="messagetoRespond(message)"
                          v-bind="attrs"
                          v-on="on"
                          class="ms-2"
                        >
                          <Icon
                            :height="18"
                            :color="'rgb(116, 116, 116)'"
                            :icon="'corner-up-left-alt'"
                          />
                        </button>
                      </template>
                      <span>Responder</span>
                    </v-tooltip>
                  </div>
                  <span
                    v-if="message.author.organization_name"
                    class="org-name"
                  >
                    {{ message.author.organization_name }}
                  </span>
                  <div class="d-flex justify-space-between mb-1 text--secondary">
                    <small>{{ message.author.name }}</small>
                  </div>
                </div>
                <div>
                  <small v-html="message.message"></small>
                </div>
              </v-sheet>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    Icon: () => import(/* webpackPrefetch: true */ '@/components/Icon.vue')
  },
  watch: {
    'messages': function () {
      this.updateScroll()
    }
  },
  computed: {
    messages () {
      return this.$store.state.rooms.item.chat.messages
    }
  }
})
export default class Messages extends Vue {
  beforeDestroy () {
    this.$store.state.rooms.item.chat.messages = []
  }

  creationTime (date) {
    const creationTime = new Date(date)
    const minutes = creationTime.getMinutes()
    return `${creationTime.getHours()}:${minutes < 10 ? '0' : ''}${minutes}`
  }

  updateScroll () {
    setTimeout(() => {
      const lastMessageElement = document.querySelector('.message-cont:last-child')
      if (lastMessageElement) {
        lastMessageElement.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'end' })
      }
    }, 200)
  }

  messagetoRespond(parentMessage) {
    this.$emit("messagetoRespond", parentMessage)
  }
}
</script>

<style scoped>
  .messages-container {
    overflow-y: scroll;
  }

  .message-cont {
    margin-bottom: 10px;
    border-radius: 5px;
  }

  .message-cont:last-child {
    margin-bottom: 0px;
  }

  .message-card{
    overflow-wrap: anywhere;
    width: 100%;
  }
  .message-card .w-100{
    width: 100%;
  }
  .reply{
    border-left: 2px solid rgb(116, 116, 116);
    padding-left: 10px;
  }
  .org-name, .reply, .header-data{
    font-size: 11px;
    color: rgb(116, 116, 116);
  }
  .org-name{
    margin-bottom: -2px;
    display: block;
  }
  .header-data{
    position: absolute;
    top:5px;
    right: 0;
    display: flex;
    align-items: top;
    font-size: 13px;
  }
</style>
